export default __webpack_public_path__ + "static/cta-1-240136bb6671239f32e385f128e15126.webp";